(function () {

  'use strict';

  angular.module('eclipseApp.core').controller('NotifierLoadingModalCtrl', ['$scope', '$modalInstance', function ($scope, $modalInstance) {

    $scope.errorMsg = '';
    $scope.$on('NotifierLoading:Done', function(ev, args){
      $modalInstance.close();
    });
    $scope.$on('NotifierLoading:Stop', function(ev, args){
      $scope.errorMsg = 'I\'m sorry we encountered an issue while proccessing your request.';
    });

    $scope.ok = function () {
      $modalInstance.close();
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };


  }]);

})();
